import Api from '@/api/api.js'

/**
 * Listes paginées côté serveur (15/10/2026) : catalogue des prestations, laboratoire, grilles tarifaires, admissions
 * et séjours, actes et soins. Chaque appel envoie `page`, `per_page` et `q` (et `type_facturation` pour les grilles) ;
 * la réponse est { data, current_page, last_page, per_page, total, from, to }.
 * Sans ces paramètres, les mêmes endpoints renvoient la liste complète (impression, export, autres écrans).
 */
const lire = (url, params) => Api().get(url, { params: params }).then(response => response.data)
const envoyer = (url, data) => Api().post(url, data).then(response => response.data)

export default {
    // Catalogue des prestations
    typesConsultations(params) {
        return lire('/types_consultations', params)
    },
    typesExamens(params) {
        return lire('/type_examens', params)
    },
    chirurgies(params) {
        return lire('/config/chirurgies', params)
    },
    bilansSante(params) {
        return lire('/bilan-sante/liste', params)
    },

    // Laboratoire et imagerie : catégories (avec nombre d'analyses), puis une page d'analyses par catégorie
    categoriesAnalyses() {
        return lire('/categories_analyses/liste/resume')
    },
    analysesCategorie(categorie_id, params) {
        return lire('/categories_analyses/' + categorie_id + '/analyses', params)
    },

    // Grilles tarifaires (assur_id : 0 = sans assurance)
    tarifConsultations(categorie_id, assur_id, params) {
        return lire('/assurances/tarification/consultation/' + categorie_id + '/0/' + assur_id, params)
    },
    tarifAnalyses(assur_id, params) {
        return lire('/assurances/tarification/analyses/0/' + assur_id, params)
    },
    tarifExamens(assur_id, params) {
        return lire('/assurances/tarification/examens/0/' + assur_id, params)
    },
    tarifChirurgies(assur_id, params) {
        return lire('/assurances/tarification/chirurgies/0/' + assur_id, params)
    },
    tarifMedicaments(assur_id, params) {
        return lire('/assurances/tarification/medicaments/0/' + assur_id, params)
    },
    tarifBilansSante(assur_id, params) {
        return lire('/assurances/tarification/bilan-sante/0/' + assur_id, params)
    },
    // Corps : { assurance_id, page, per_page, q, type_facturation }
    tarifActes(data) {
        return envoyer('/assurances/tarification/acte', data)
    },
    // Corps : { assurance_id, data_type: 'admission' | 'chambre' | 'observation', page, per_page, q }
    tarifTypesAdmission(data) {
        return envoyer('/assurances/tarification/type-admission', data)
    },
    // Corps : { assurance_id, data_type, page, per_page, q }
    tarifConsommables(data) {
        return envoyer('/assurances/tarification/consommable', data)
    },

    // Admissions et séjours (data_type : admission | chambre | observation), actes et soins (type_acte : acte | autre_acte)
    typesAdmission(data_type, params) {
        return lire('/parametres/admissions/' + data_type + '/liste', params)
    },
    actes(type_acte, params) {
        return lire('/prestations/actes/' + type_acte, params)
    },
}
